import { render, staticRenderFns } from "./ImageCard3.vue?vue&type=template&id=159dd4d5&"
import script from "./ImageCard3.vue?vue&type=script&lang=js&"
export * from "./ImageCard3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports